// Absolute routes used by the root app router when redirecting into Toast app.
const T_ROUTES = {
    MENU: '/v1/menu',
    CATEGORY: '/v1/category',
    CHECKOUT: '/v1/checkout',
    CONFIRMATION: '/v1/confirmation',
} as const;

// Relative route segments used inside ToastApp, which is mounted at /v1/*.
export const T_ROUTE_SEGMENTS = {
    MENU: 'menu',
    CATEGORY: 'category',
    CHECKOUT: 'checkout',
    CONFIRMATION: 'confirmation/:orderNumber',
} as const;

export default T_ROUTES;
